import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-container">
        <div className="privacy-policy-header">
          <h1>Privacy Policy</h1>
          <p>Last Updated: September 12, 2026</p>
        </div>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to <strong>ALEXGOA.COM</strong>. We respect your privacy
            and are committed to protecting the information you may provide
            while using our website and services.
          </p>

          <p>
            This Privacy Policy explains how information may be collected,
            used, stored, disclosed, and protected when you access or use
            <strong> www.alexgoa.com</strong>.
          </p>

          <p>
            By accessing or using our website, you acknowledge that you have
            read and understood this Privacy Policy. If you do not agree with
            any part of this policy, please discontinue use of the website.
          </p>
        </section>

        <section>
          <h2>2. Information We May Collect</h2>

          <p>
            Depending on how you interact with our website, we may collect
            information that you voluntarily provide or information that is
            automatically generated when you use the website.
          </p>

          <h3>Information You Provide</h3>
          <ul>
            <li>Name and contact details</li>
            <li>Email address or telephone number</li>
            <li>Information submitted through contact forms</li>
            <li>Information provided when requesting our services</li>
            <li>Customer support communications</li>
            <li>Other information you voluntarily choose to provide</li>
          </ul>

          <h3>Technical Information</h3>
          <p>
            When you access our website, certain technical information may be
            collected automatically, depending on the technologies used by the
            website. This may include:
          </p>

          <ul>
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Device type</li>
            <li>Operating system</li>
            <li>Approximate location derived from technical information</li>
            <li>Pages visited</li>
            <li>Time and date of visits</li>
            <li>Website usage and interaction information</li>
            <li>Technical log information</li>
          </ul>

          <p>
            The exact categories of information collected may depend on the
            features and technologies available on the website.
          </p>
        </section>

        <section>
          <h2>3. How We Use Information</h2>

          <p>
            Information may be used for legitimate business and operational
            purposes, including:
          </p>

          <ul>
            <li>Providing and maintaining our website</li>
            <li>Responding to enquiries and requests</li>
            <li>Providing customer support</li>
            <li>Communicating with users</li>
            <li>Improving website performance and functionality</li>
            <li>Monitoring website security</li>
            <li>Preventing fraud, abuse, or unauthorized activity</li>
            <li>Troubleshooting technical problems</li>
            <li>Maintaining business and service records</li>
            <li>Complying with applicable legal obligations</li>
            <li>Enforcing our terms, policies, and legal rights</li>
          </ul>

          <p>
            Where marketing communications are sent, users may have the right
            to opt out of receiving such communications, subject to applicable
            law.
          </p>
        </section>

        <section>
          <h2>4. Cookies and Similar Technologies</h2>

          <p>
            Cookies are small text files that websites may place on a user's
            device. They can help websites remember preferences, improve
            functionality, and understand how visitors use a website.
          </p>

          <p>
            Depending on the technologies implemented on ALEXGOA.COM, cookies
            or similar technologies may be used for purposes such as:
          </p>

          <ul>
            <li>Essential website functionality</li>
            <li>Remembering user preferences</li>
            <li>Website performance and analytics</li>
            <li>Security and fraud prevention</li>
            <li>Other functionality provided by third-party services</li>
          </ul>

          <p>
            You can generally control or disable cookies through your browser
            settings. Disabling certain cookies may affect some website
            functionality.
          </p>
        </section>

        <section>
          <h2>5. Legal Basis for Processing</h2>

          <p>
            Where applicable privacy and data-protection laws require a legal
            basis for processing personal information, information may be
            processed on one or more of the following grounds:
          </p>

          <ul>
            <li>Your consent</li>
            <li>Performance of a contract or requested service</li>
            <li>Our legitimate business interests</li>
            <li>Compliance with legal obligations</li>
            <li>Protection of our website, users, and business interests</li>
          </ul>

          <p>
            The applicable legal basis may depend on the nature of the
            information and the circumstances in which it is collected.
          </p>
        </section>

        <section>
          <h2>6. How Information May Be Shared</h2>

          <p>
            We may disclose information where reasonably necessary for
            operating the website, providing services, protecting our
            business, or complying with applicable law.
          </p>

          <p>Depending on the circumstances, information may be shared with:</p>

          <ul>
            <li>Service providers working on our behalf</li>
            <li>Website hosting or infrastructure providers</li>
            <li>Technical and security service providers</li>
            <li>Professional advisers</li>
            <li>Payment providers, where applicable</li>
            <li>Analytics or technology providers, where applicable</li>
            <li>Government or regulatory authorities when legally required</li>
          </ul>

          <p>
            We do not intend to sell personal information as a commercial
            product. Any data-sharing practices should be understood in the
            context of the services and technologies actually used by the
            website.
          </p>
        </section>

        <section>
          <h2>7. Payment Information</h2>

          <p>
            If payment functionality is made available through the website,
            payment information may be processed by third-party payment
            providers.
          </p>

          <p>
            Where third-party payment services are used, those providers may
            process payment information according to their own privacy
            policies and terms.
          </p>

          <p>
            ALEXGOA.COM will not claim to store or process payment-card
            information directly unless such practices are specifically
            confirmed and implemented.
          </p>
        </section>

        <section>
          <h2>8. Data Retention</h2>

          <p>
            Personal information should generally be retained only for as long
            as reasonably necessary for the purposes for which it was
            collected, including:
          </p>

          <ul>
            <li>Providing requested services</li>
            <li>Maintaining business records</li>
            <li>Resolving disputes</li>
            <li>Protecting website and business security</li>
            <li>Meeting accounting or record-keeping requirements</li>
            <li>Complying with applicable legal obligations</li>
          </ul>

          <p>
            The actual retention period may vary depending on the type of
            information and applicable legal or business requirements.
          </p>
        </section>

        <section>
          <h2>9. Data Security</h2>

          <p>
            We take reasonable administrative, organizational, and technical
            measures designed to protect personal information against
            unauthorized access, misuse, alteration, disclosure, or loss.
          </p>

          <p>
            However, no method of transmission over the internet or method of
            electronic storage can be guaranteed to be completely secure.
            Therefore, we cannot guarantee absolute security of information
            transmitted to or stored by the website.
          </p>
        </section>

        <section>
          <h2>10. International Data Transfers</h2>

          <p>
            Depending on the service providers, hosting arrangements, and
            technologies used by the website, information may potentially be
            processed or stored in countries other than the country in which
            you are located.
          </p>

          <p>
            Where applicable law requires safeguards for international data
            transfers, appropriate measures should be implemented in accordance
            with that law.
          </p>
        </section>

        <section>
          <h2>11. Your Privacy Rights</h2>

          <p>
            Depending on your location and applicable privacy law, you may have
            certain rights regarding your personal information.
          </p>

          <p>These rights may include:</p>

          <ul>
            <li>Requesting access to personal information</li>
            <li>Requesting correction of inaccurate information</li>
            <li>Requesting deletion of personal information</li>
            <li>Requesting restriction of certain processing</li>
            <li>Objecting to certain processing activities</li>
            <li>Requesting data portability where applicable</li>
            <li>Withdrawing consent where processing is based on consent</li>
            <li>Opting out of certain marketing communications</li>
            <li>
              Filing a complaint with an applicable data-protection authority
            </li>
          </ul>

          <p>
            These rights are subject to applicable law and may not be available
            in every situation. Requests may be subject to reasonable
            verification requirements.
          </p>
        </section>

        <section>
          <h2>12. Children's Privacy</h2>

          <p>
            Our website is not intended to knowingly collect personal
            information from children where such collection is prohibited by
            applicable law.
          </p>

          <p>
            If you believe that a child has provided personal information to us
            in circumstances where such collection should not have occurred,
            please contact us so that the matter can be reviewed and
            appropriate action can be taken.
          </p>
        </section>

        <section>
          <h2>13. Third-Party Links</h2>

          <p>
            Our website may contain links to third-party websites, applications,
            platforms, or services.
          </p>

          <p>
            We are not responsible for the privacy practices, content, security,
            or policies of third-party websites. We encourage users to review
            the privacy policies of third-party services before providing them
            with personal information.
          </p>
        </section>

        <section>
          <h2>14. Third-Party Services</h2>

          <p>
            Certain website functions may rely on third-party services,
            technologies, or infrastructure. The specific providers used by
            ALEXGOA.COM may change over time.
          </p>

          <p>
            Where third-party providers process personal information on our
            behalf, their access should be limited to information reasonably
            necessary for the services they provide, subject to applicable
            agreements and laws.
          </p>
        </section>

        <section>
          <h2>15. Advertising and Analytics</h2>

          <p>
            ALEXGOA.COM may use analytics, advertising, or other measurement
            technologies if these services are implemented on the website.
          </p>

          <p>
            The specific analytics and advertising providers used should be
            confirmed and listed in this Privacy Policy before publication if
            they collect or process personal information.
          </p>
        </section>

        <section>
          <h2>16. Do Not Track and Browser Privacy Controls</h2>

          <p>
            Some web browsers provide privacy settings or signals designed to
            communicate user preferences regarding online tracking.
          </p>

          <p>
            The handling of such signals may depend on the technologies and
            services implemented on the website. We do not make any specific
            claim regarding support for particular browser privacy signals
            unless such functionality has been confirmed.
          </p>
        </section>

        <section>
          <h2>17. Changes to This Privacy Policy</h2>

          <p>
            We may update this Privacy Policy from time to time to reflect
            changes to our website, services, business practices, or applicable
            legal requirements.
          </p>

          <p>
            When changes are made, the updated version will be published on this
            page with a revised "Last Updated" date.
          </p>

          <p>
            Where appropriate, significant changes may also be communicated
            through reasonable means available to us.
          </p>
        </section>

        <section>
          <h2>18. Contact Us</h2>

          <p>
            If you have questions, concerns, or requests relating to this
            Privacy Policy or the handling of personal information, please
            contact us using the details below.
          </p>

          <div className="privacy-contact-box">
            <p>
              <strong>Website:</strong> www.alexgoa.com
            </p>
            <p>
              <strong>Business Name:</strong> alexgoa
            </p>
            <p>
              <strong>Email:</strong> Alexgoa9560@gmail.com
            </p>
            <p>
              <strong>Address:</strong> Al Kifaf Oasis Building, Al Kifaf, Dubai, United Arab Emirates
            </p>
          </div>
        </section>

        <section className="privacy-notice">
          <h2>Important Notice</h2>

          <p>
            This Privacy Policy is intended to provide a general framework for
            privacy practices. Certain details, including the legal business
            identity, contact information, cookies, analytics tools, payment
            providers, hosting providers, data-retention practices, and
            applicable jurisdiction, should be reviewed and customised before
            this policy is treated as the final legal policy for the website.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;